<template>
  <div class="copyright">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12 text-center">
          Copyright {{date()}} - Direitos reservados. Feito com
          <a href="http://o2.ag/portal_rh" target="_blank">
            <img src="../assets/img/amor.png" alt="amor">
          </a>
          por
          <a href="http://odoisgo.com" target="_blank">
            <img src="../assets/img/odois.png?v=1" alt="ó Dois">
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    date () {
      var date = new Date()
      return date.getFullYear()
    }
  }
}
</script>
<style lang="scss" scoped>
.copyright {
  background: #0f1425;
  padding: 20px 0 0;
  font-size: 16px;
  color: white;
  img {
    margin: 0 5px;
  }
  @media screen and (max-width: 768px) {
    padding-bottom: 90px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Copyright.vue